import React from "react";
import projectImage1 from "../../assets/medicare1.png";
import projectImage2 from "../../assets/UniGlobeEdu.png";
import projectImage3 from "../../assets/Ema-Jhon-Web.png";
import Typewriter from "typewriter-effect";
import "./Works.css";
const Works = () => {
  return (
    <section className="work_container" id="work">
      <h2 className="section_title">Recent Works</h2>
      <span className="section_subtitle">LIVE SITE AND CODE</span>
      <div className="work_filters">
        <span className="work_item">MERN</span>
        <span className="work_item">FRONTEND</span>
        <span className="work_item">BackEnd</span>
        <span className="work_item">FullStack</span>
      </div>

      <div className="work_container container grid grid-cols-1 lg:grid-cols-4">
        <div className="work_card">
          <h3 className="work_title">
            <Typewriter
              onInit={(typewriter) => {
                typewriter
                  .typeString(" A HealthCare Web App")
                  .pauseFor(1000)
                  .deleteAll()
                  .typeString("Technology Used:  React, FireBase")
                  .start();
              }}
            />
          </h3>

          <img src={projectImage1} alt="" className="work_img" />

          <a href="https://medicaredhaka.netlify.app/" className="work_button">
            {" "}
            <button class="cta">
              <span>Live Site</span>
              <svg viewBox="0 0 13 10" height="10px" width="15px">
                <path d="M1,5 L11,5"></path>
                <polyline points="8 1 12 5 8 9"></polyline>
              </svg>
            </button>
          </a>

          <a
            href="https://github.com/Programming-Hero-Web-Course3/healthcare-related-website-SakibSaizeed"
            className="work_button"
          >
            {" "}
            <button class="cssbuttons-io">
              <span>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0h24v24H0z" fill="none"></path>
                  <path
                    d="M24 12l-5.657 5.657-1.414-1.414L21.172 12l-4.243-4.243 1.414-1.414L24 12zM2.828 12l4.243 4.243-1.414 1.414L0 12l5.657-5.657L7.07 7.757 2.828 12zm6.96 9H7.66l6.552-18h2.128L9.788 21z"
                    fill="currentColor"
                  ></path>
                </svg>{" "}
                Code
              </span>
            </button>
          </a>
        </div>

        <div className="work_card">
          <h3 className="work_title">
            <Typewriter
              onInit={(typewriter) => {
                typewriter
                  .typeString("Education Consultancy Web App")
                  .pauseFor(1000)
                  .deleteAll()
                  .typeString("Made With React, ES6, Express, Node")
                  .start();
              }}
            />
          </h3>

          <img src={projectImage2} alt="" className="work_img" />

          <a href="https://www.uniglobeedu.com/" className="work_button">
            {" "}
            <button class="cta">
              <span>Live Site</span>
              <svg viewBox="0 0 13 10" height="10px" width="25px">
                <path d="M1,5 L11,5"></path>
                <polyline points="8 1 12 5 8 9"></polyline>
              </svg>
            </button>
          </a>

          <a
            href="https://github.com/SakibSaizeed/uniglobeuk.git"
            className="work_button"
          >
            {" "}
            <button class="cssbuttons-io">
              <span>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0h24v24H0z" fill="none"></path>
                  <path
                    d="M24 12l-5.657 5.657-1.414-1.414L21.172 12l-4.243-4.243 1.414-1.414L24 12zM2.828 12l4.243 4.243-1.414 1.414L0 12l5.657-5.657L7.07 7.757 2.828 12zm6.96 9H7.66l6.552-18h2.128L9.788 21z"
                    fill="currentColor"
                  ></path>
                </svg>{" "}
                Code
              </span>
            </button>
          </a>
        </div>
        <div className="work_card">
          <h3 className="work_title">An E-commerce Web</h3>
          <img src={projectImage3} alt="" className="work_img" />
          <a
            href="https://ema-jhon-react-17454.web.app/"
            className="work_button"
          >
            {" "}
            <button class="cta">
              <span>Live Site</span>
              <svg viewBox="0 0 13 10" height="10px" width="15px">
                <path d="M1,5 L11,5"></path>
                <polyline points="8 1 12 5 8 9"></polyline>
              </svg>
            </button>
          </a>

          <a
            href="https://github.com/SakibSaizeed/project-ema-jhon-react.git"
            className="work_button"
          >
            {" "}
            <button class="cssbuttons-io">
              <span>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0h24v24H0z" fill="none"></path>
                  <path
                    d="M24 12l-5.657 5.657-1.414-1.414L21.172 12l-4.243-4.243 1.414-1.414L24 12zM2.828 12l4.243 4.243-1.414 1.414L0 12l5.657-5.657L7.07 7.757 2.828 12zm6.96 9H7.66l6.552-18h2.128L9.788 21z"
                    fill="currentColor"
                  ></path>
                </svg>{" "}
                Code
              </span>
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Works;
